export interface IClaimResponse {
  status: number
  message: string
  error: string
  resultData: IResultData
}

interface IResultData {
  uploadId: string,
  totalReadyForSubmissionClaims: number,
  totalValidationErrorClaims: number,
  totalNotUploadedClaims: number,
  totalClaims: number
}

export const uploadConfig = {
  entityName: 'CLAIM.CLAIM',
};